<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>text_snippet</md-icon>
      </div>
      <h4 class="title">
        Notes
      </h4>
    </md-card-header>
    <md-card-content>
      <text-editor v-model="newNoteContent" />
      <md-button
        class="md-dense md-primary"
        @click="save"
        :disabled="saving"
        style="margin-top: 1rem"
      >
        <md-icon>save</md-icon>
        Save
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";

export default {
  props: ["manifest", "departureId"],

  data() {
    return { saving: false };
  },

  computed: {
    newNoteContent: {
      get() {
        return this.manifest.notes;
      },
      set(newValue) {
        this.manifest.notes = newValue;
      }
    }
  },

  methods: {
    save() {
      if (this.saving) return;
      this.saving = true;
      return departureApi
        .saveManifestText(this.departureId, "notes", this.manifest.notes)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: "Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {
          const message = error.response?.data?.message;
          this.$notify({
            timeout: 5000,
            message:
              typeof message === "object" && message
                ? Object.values(message)
                    .flat()
                    .join(" ")
                : message || "Unable to save. Please try again.",
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
<style lang="scss"></style>
